import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons/faExclamationTriangle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Icon for chat messages that failed to send. This is a separate component for testing purposes.
 * @returns Icon.
 */
const ErrorIcon = () => <FontAwesomeIcon icon={faExclamationTriangle} />;

export default ErrorIcon;
